import React, { useMemo } from "react";
import stl from "../styles/fmRadio.module.scss";
import classnames from "classnames";
import {
    IStyleProps,
    WholePropsIncludeAddPreFixAndOtherProps,
    Size,
} from "../interface";
import {
    FormControl,
    FormControlLabel,
    FormControlLabelProps,
    FormControlProps,
    FormHelperText,
    Radio,
    RadioGroup,
    RadioProps,
} from "@mui/material";
import { IFormControlLabel } from "./FmCheckbox";
import FmIcon from "./FmIcon";

type IFormLabel = WholePropsIncludeAddPreFixAndOtherProps<
    RadioProps,
    FormControlLabelProps,
    "radio"
> &
    IFormControlLabel<string | number>;
interface IRadioProps<T> extends IStyleProps {
    dataSource: Array<
        Omit<IFormLabel, "size"> & {
            size?: Size;
        }
    >;
    error?: FormControlProps["error"];
    note?: string;
    value: T;
    onChange?: (event: React.ChangeEvent, value: T) => void;
    noteClassName?: string;
    type?: "circle" | "square";
    formControlProps?: Omit<FormControlProps, "error">;
}

const defaultProps = {
    note: "",
    error: false,
};
const FmRadio = (props: IRadioProps<string | number>) => {
    // TODO: 监听value更改
    const { type = "rectangle", ...restProps } = props;
    const radioList = useMemo(() => {
        return props.dataSource.map((item) => {
            const {
                formControlLabelClassName,
                labelClassName,
                radioChecked,
                radioValue,
                radioOnChange,
                size,
                ...restItem
            } = item;
            return (
                <FormControlLabel
                    className={classnames(
                        stl["form-control-label"],
                        stl[type],
                        formControlLabelClassName,
                    )}
                    key={`${item.label}`}
                    value={radioValue}
                    control={
                        <Radio
                            checked={radioChecked}
                            // onChange={radioOnChange}
                            className={stl["radio-label-item"]}
                            size={size === "large" ? "medium" : size}
                            icon={<></>}
                            checkedIcon={
                                type === "square" ? (
                                    <FmIcon
                                        icon={"icon--checked"}
                                        className={stl["checked-icon-font"]}
                                    />
                                ) : (
                                    <span className={stl["checked-circle"]} />
                                )
                            }
                            classes={{
                                root: stl["radio-root"],
                                checked: stl["radio-checked"],
                            }}
                            {...restItem}
                        />
                    }
                    label={item.label}
                    classes={{
                        label: classnames(stl["form-label"], labelClassName),
                    }}
                />
            );
        });
    }, [props.dataSource, type]);
    return (
        <FormControl
            error={props.error}
            variant="standard"
            className={stl["form-control"]}
            {...props.formControlProps}
        >
            <RadioGroup
                className={classnames(props.className, stl["form-group"])}
                style={props.style}
                name="radio-buttons-group"
                value={props.value}
                onChange={(e, v) => {
                    props.onChange?.(e, v);
                }}
            >
                {radioList}
            </RadioGroup>
            <FormHelperText
                className={classnames(stl["note"], props.noteClassName, {
                    ["hidden"]: !props.note,
                })}
            >
                {props.note}
            </FormHelperText>
        </FormControl>
    );
};

export default FmRadio;
